import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { getTicketsLoading, getTotalOpenTickets, State } from 'src/app/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { WidgetTicketsDisplayComponent } from '../../../../shared/components/widget-displays/widget-tickets-display/widget-tickets-display.component';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-ons-widget-tickets',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetTicketsDisplayComponent, SharedModule],
  template: `
    <app-widget-tickets-display
      class="dimensions-stretch"
      [hyperlink]="'/tickets'"
      [queryParams]="{ groupBy: 'Type' }"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [ticketCount]="totalOpenTickets()"
    ></app-widget-tickets-display>
  `,
})
export class WidgetTicketsComponent {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  readonly totalOpenTickets = toSignal<number>(
    this.store.select(getTotalOpenTickets),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getTicketsLoading));
}
